
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";

interface BulkActionBarProps {
  selectedCount: number;
  onFeatureSelected: () => void;
}

export const BulkActionBar = ({ selectedCount, onFeatureSelected }: BulkActionBarProps) => {
  if (selectedCount === 0) return null;

  return (
    <div className="p-4 bg-muted/30 rounded-lg flex items-center justify-between">
      <span className="text-sm font-medium">{selectedCount} reviews selected</span>
      <Button 
        variant="outline" 
        size="sm"
        onClick={onFeatureSelected}
        className="gap-2"
      >
        <Star className="h-4 w-4" />
        Feature Selected
      </Button>
    </div>
  );
};

